import React from "react";
import { useNavigate } from "react-router-dom";
import optionalSubjects from "../../data/syllabus-data/optionalSubjects";

export default function OptionalSubjects() {
  const navigate = useNavigate();

  return (
    <section id="OptionalSubject" className="w-full bg-gray-50 py-12 px-6">
      <div className="px-6 py-10 bg-gray-50 min-h-screen">
        <h2 className="text-3xl font-bold text-blue-900 mb-2">
          Optional Subjects
        </h2>
        <h3 className="text-lg font-semibold text-red-600 mb-4">Overview</h3>
        <p className="text-gray-700 mb-8 max-w-4xl">
          Candidates must choose one optional subject (two papers). The choice
          should be strategic, based on interest and overlap with GS papers.
        </p>

        {/* Subject Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {optionalSubjects.map((subject, index) => (
            <div
              key={index}
              onClick={() => {
                window.scrollTo({ top: 0, behavior: "smooth" });
                navigate(
                  `/optional-subject/${encodeURIComponent(subject.title)}`
                );
              }}
              className={`cursor-pointer bg-white rounded-xl shadow-md border-t-4 ${
                index % 2 === 0 ? "border-red-600" : "border-blue-700"
              } hover:shadow-xl transition duration-300 p-6`}
            >
              <h4 className="text-lg font-semibold text-gray-900 mb-2">
                {subject.title}
              </h4>
              <p className="text-gray-600 text-sm">{subject.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
